import {
  inject,
  Inject,
  Injectable,
  Optional,
  PLATFORM_ID,
} from '@angular/core';
import { LOCALSTORAGE } from '../utils/localstorage.token';
import { isPlatformBrowser } from '@angular/common';
import { DOCUMENT } from '../utils/document.token';
import { globals } from '../../globals';

/**
 * Итак, используются только куки без httpOnly
 * Логика такая. в server.ts мы мидлварим и чекаем куки на предет в них jwt
 * Если они есть, то провайдим их для приложения, если нет то нет
 *
 * Когда грузится в браузере, то мы берем то что запровайдили на серваке, если ничего нет
 * берем из кук напрямую.
 * И если вообще ничего нигде нет то ок)
 * Гидратация не восстанавливает провайдеры компонентов / их значения и тд, она инжектит их заново
 *
 * Когда сервер сср делает запросы к беку внутри сервака, то он не передаеткуки и тд, мы должны
 * взять из в сервисе или интерсепторе и получить из этого сервиса
 * */

@Injectable({ providedIn: 'root' })
export class BrowserService {
  public readonly isBrowser!: boolean;
  public readonly localStorage!: Storage;
  public readonly document!: Document;

  constructor(
    @Optional()
    @Inject(LOCALSTORAGE)
    private readonly localStorageInjector: Storage,
    @Optional() @Inject(DOCUMENT) private documentInjector: Document
  ) {
    if (this.localStorageInjector) {
      this.localStorage = localStorageInjector;
    }
    if (this.documentInjector) {
      this.document = documentInjector;
    }

    this.isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
  }

  public getCookie(name: string) {
    if (this.document) {
      const value = `; ${this.document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop()?.split(';').shift() as string;
    }
    return undefined;
  }

  // get(key: string) {
  //   //check if browser or not
  //   return this.isBrowser ? this.storage.getItem(key) : null;
  // }
  removeCookie(name: string) {
    document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=${
      globals.domain === 'localhost' ? globals.domain : '.' + globals.domain
    }`;
  }

  setCookie(name: string, data: string, ttlMinutes: number = 5) {
    let cookieStr = encodeURIComponent(name) + '=' + encodeURIComponent(data);
    const dtExpires = new Date();
    dtExpires.setMinutes(dtExpires.getMinutes() + ttlMinutes);
    cookieStr += ';expires=' + dtExpires.toUTCString();
    cookieStr += ';path=/';
    cookieStr += ';samesite=lax';

    document.cookie = cookieStr;
  }
}
